import { resolveWidgetConfig } from './signalKValueFormat';

/** Normalize API widget shape for editor + view (name, type, config aliases). */
export function normalizeWidget(widget, overrides = {}) {
  if (!widget) return widget;
  const config = resolveWidgetConfig(widget);
  const name = widget.name || widget.widget_name || 'Untitled Widget';
  const type = widget.type || widget.widget_type || 'digital';

  return {
    ...widget,
    ...overrides,
    name,
    widget_name: widget.widget_name || name,
    type,
    widget_type: widget.widget_type || type,
    sectionId: overrides.sectionId ?? widget.sectionId ?? widget.section_id,
    section_id: widget.section_id ?? widget.sectionId,
    config,
    display_config: config,
  };
}

export function normalizeWidgets(widgets) {
  return (widgets || []).map((w) => normalizeWidget(w));
}

export function widgetDisplayName(widget) {
  return widget?.name || widget?.widget_name || 'Untitled Widget';
}

/** Payload for PUT/POST widget — always includes DB column names. */
export function widgetApiPayload(widgetData) {
  const config = resolveWidgetConfig(widgetData);
  const name = widgetData.name || widgetData.widget_name || 'Untitled Widget';
  const type = widgetData.type || widgetData.widget_type || 'digital';
  const layoutWidth = widgetData.width || config.layoutWidth || 'third';
  const mergedConfig = {
    ...config,
    layoutWidth,
  };

  return {
    ...widgetData,
    name,
    widget_name: name,
    type,
    widget_type: type,
    width: layoutWidth,
    config: mergedConfig,
    display_config: mergedConfig,
  };
}

/** Layout-only payload for dashboard save — never overwrites widget config in DB. */
export function dashboardLayoutPayload(sections, dashboardName) {
  return {
    name: dashboardName,
    sections: (sections || []).map((section, sectionIndex) => ({
      id: section.id,
      name: section.name || section.section_name,
      section_name: section.section_name || section.name,
      columns: section.columns ?? section.max_widgets_per_row,
      max_widgets_per_row: section.max_widgets_per_row ?? section.columns,
      position: sectionIndex,
      widgets: (section.widgets || []).map((widget, widgetIndex) => ({
        id: widget.id,
        position: widgetIndex,
        sectionId: section.id,
        section_id: section.id,
      })),
    })),
  };
}

export function isTemperaturePath(path) {
  if (!path || typeof path !== 'string') return false;
  return /temperature|\.temp\b|Temp/i.test(path);
}
